module.exports = __webpack_public_path__ + "img/49ne.66c911ab.svg";